module.exports = __webpack_public_path__ + "img/5E5855_C6C4CD_C89B67_8F8E98-256px.5d6d777d.png";